import(/* webpackMode: "eager" */ "/tmp/publish-tmp/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/node_modules/@mui/material/CssBaseline/CssBaseline.mjs");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/tmp/publish-tmp/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/publish-tmp/public/css/fonts.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/publish-tmp/src/utils/theme-registry.tsx");
